import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend, { type BackendError } from "@/utils/fetchToBackend";
import { contractingKeys } from "@/lib/query-keys";
import { toastUtil } from "@/utils/toastUtil";
import type { QualificationStatus } from "@/types/domain";

/** El botón "Analizar": lanza el cruce de lo que no está al día y deja el estado en caché. */
export function useAnalyzeQualification() {
  const qc = useQueryClient();
  return useMutation<QualificationStatus, BackendError, void>({
    mutationFn: () =>
      fetchToBackend<QualificationStatus>("/organization/qualification/analyze", {
        method: "POST",
      }),
    onSuccess: (status) => qc.setQueryData(contractingKeys.qualification(), status),
    onError: (error) =>
      toastUtil(error.message || "No se pudo lanzar el análisis.", "error"),
  });
}
